import React from 'react';
import { IonList, IonItem } from '@ionic/react';

import { ROUTES } from '$gbusiness/enums';

interface PopMenuProps {
  onDismiss?: () => void;
  onClick?: (action) => void;
}

const PopMenu: React.FC<PopMenuProps> = ({ onClick }) => {
  return (
    <IonList>
      <IonItem onClick={onClick} routerLink={`${ROUTES.USERS}/new`}>
        TEST MENU
      </IonItem>
    </IonList>
  );
};

export default PopMenu;
